import React, { forwardRef, useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const DebitCreditDrop = forwardRef(
  (
    { control, name, onSelectChange, target, dropView, placeholder },
    forwardedRef
  ) => {
    const [isLoading, setIsLoading] = useState(true)
    const [countriesData, setCountriesData] = useState([])

    const loadOptions = async () => {
      const data = [
        { label: "Dr", value: "debit" },
        { label: "Cr", value: "credit" },
      ]
      setIsLoading(false)
      const countries = data.map(dta => {
        return {
          label: dta?.label && ucfirst(dta.label),
          value: dta.id,
          ...dta,
        }
      })

      setCountriesData(countries)
    }

    useEffect(() => {
      loadOptions()
    }, [])

    return (
      <div>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, ref, value } }) => {
            return (
              <Select
                options={countriesData}
                // placeholder={placeholder ? placeholder : "Select"}
                placeholder={
                  <div className="css-placeholder">
                    {placeholder || "Select"}
                  </div>
                }
                isLoading={isLoading}
                inputRef={ref}
                ref={selectRef => {
                  // Forward the ref to both react-hook-form and parent component
                  ref(selectRef)
                  if (forwardedRef) {
                    if (typeof forwardedRef === "function") {
                      forwardedRef(selectRef)
                    } else {
                      forwardedRef.current = selectRef
                    }
                  }
                }}
                onChange={e => {
                  onChange(e)
                  if (onSelectChange) onSelectChange(e)
                }}
                value={value}
                classNamePrefix="react-select"
                className="elevate-dropdown"
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                menuPlacement={dropView ? "top" : "bottom"}
                // menuPortalTarget={document.querySelector(
                //   target ? target : "body"
                // )}
                onKeyDown={e => {
                  // Prevent default Tab behavior since we're handling it in parent
                  if (e.key === "Tab") {
                    e.preventDefault()
                  }
                }}
              />
            )
          }}
        />
      </div>
    )
  }
)
DebitCreditDrop.displayName = "DebitCreditDrop"

export default DebitCreditDrop
